import LabelInputBorderFull from "../../components/labelInputBorderFull/LabelInputBorderFull";
import { useCallback, useEffect, useState } from "react";
import {
  GeneralContainerCenter,
  H2,
  SubTitle,
  TitleLarge,
} from "../../components/UI/generalLayout/Layout.styled";
import { FilledButton } from "../../components/UI/buttons/Button";
import SuccessModal from "../../components/successModal/SuccessModal";
import { ReactComponent as MedicineCheck } from "../../assets/imgs/medicineCheck.svg";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../enums/Paths";
import CardUploadPhoto from "../../components/cardUploadPhoto/CardUploadPhoto";

import * as Yup from "yup";
import {
  handleBackendErrors,
  validateOnlyLetters,
  validateTelephone,
} from "../../helpers/HelperFunctions";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { ContainerInformations } from "./InformationsCpt.styled";
import { useSelector } from "react-redux";
import * as personActions from "../../store/actions/person";
import { useAppDispatch } from "../..";
import moment from "moment";
import Colors from "../../constants/Colors";
import imageNotPermission from "../../assets/imgs/tipos_imagem_not_permission.png";
import tamanhoImagemNotPermission from "../../assets/imgs/tamanho_not_permission.png";
import ErrorArea from "../../components/error/ErrorArea";
import LabelInputBorderFullEmail from "../../components/LabelInputBorderFullEmail/LabelInputBorderFullEmail";

function InformationsCpt() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showModalSucesso, setShowModalSucesso] = useState(false);
  const { pessoa } = useSelector((state: any) => state.person);
  const { userInfo } = useSelector((state: any) => state.login);
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState<any>();
  const [imageNotAllowedBySize, setImageNotAllowedBySize] = useState(false);
  const [imageNotAllowedByExtension, setImageNotAllowedByExtension] =
    useState(false);
  const [generalErrors, setGeneralErrors] = useState<any[]>([]);

  const onSelectFile = (e: any) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
    } else if (
      (e.target.files[0].type !== "image/jpeg" &&
        e.target.files[0].type !== "image/png" &&
        e.target.files[0].type !== "image/svg+xml")
    ) {
      setPreview(imageNotPermission)
      setImageNotAllowedByExtension(true)
      setImageNotAllowedBySize(false)
    } else if (e.target.files[0].size > 300000) {
      setPreview(tamanhoImagemNotPermission)
      setImageNotAllowedBySize(true)
      setImageNotAllowedByExtension(false)
    } else {
      setSelectedFile(e.target.files[0]);
      setImageNotAllowedByExtension(false);
      setImageNotAllowedBySize(false);
    }
  };

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl: any = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const fetchPersonData = useCallback(async () => {
    const personId = userInfo.id;
    await dispatch(personActions.fetchPerson(personId));
  }, [userInfo]);

  useEffect(() => {
    fetchPersonData();
  }, []);

  useEffect(() => {
    if (pessoa !== null) {
      const pessoaComplementar = {
        nomeCompleto: pessoa.nome ?? "",
        cpf: pessoa.cpf ?? "",
        dataNascimento:
          pessoa.dataNascimento !== null
            ? moment(pessoa.dataNascimento).format("YYYY-MM-DD")
            : "",
        nomeChamado: pessoa.comoSerChamado ?? "",
        email: pessoa.email ?? "",
        confirmaEmail: "",
        telefone1: pessoa.telefones[0] ?? "",
        telefone2: pessoa.telefones[1] ?? "",
        nomeContatoUrgencia:
          pessoa.contatos.length > 0 ? pessoa.contatos[0].nome : "",
        grauParentesco:
          pessoa.contatos.length > 0 ? pessoa.contatos[0].grauParentesco : "",
        telefoneUrgencia:
          pessoa.contatos.length > 0 ? pessoa.contatos[0].telefone : "",
        emailUrgencia:
          pessoa.contatos.length > 0 ? pessoa.contatos[0].email : "",
      };
      setInformation(pessoaComplementar);
    }
  }, [pessoa]);

  // Erros de formulário
  const [nomeError, setNomeError] = useState([]);
  const [emailError, setEmailError] = useState([]);
  const [confirmaEmailError, setConfirmaEmailError] = useState([]);
  const [tel1Error, setTel1Error] = useState([]);
  const [tel2Error, setTel2Error] = useState([]);
  const [nomeUrgentErro, setNomeUrgentError] = useState([]);
  const [grauParentescoErro, setGrauParentescoError] = useState([]);
  const [telUrgentErro, setTelUrgentError] = useState([]);
  const [emailUrgentErro, setEmailUrgentError] = useState([]);

  // Valores digitados no formulário será salvo neste objeto
  const [information, setInformation] = useState({
    nomeCompleto: "",
    cpf: "",
    dataNascimento: "",
    nomeChamado: "",
    email: "",
    confirmaEmail: "",
    telefone1: "",
    telefone2: "",
    nomeContatoUrgencia: "",
    grauParentesco: "",
    telefoneUrgencia: "",
    emailUrgencia: "",
  });

  const { isMobile } = useResponsiveInfo();

  // Essa função serve para salvar os valores
  const valueFields = (e: { target: { name: any; value: any } }) => {
    if (
      e.target.name !== "telefone1" &&
      e.target.name !== "telefone2" &&
      e.target.name !== "telefoneUrgencia"
    ) {
      setInformation({ ...information, [e.target.name]: e.target.value });
    } else {
      masktel(e.target.name, e.target.value);
    }

  };

  // Função para navegar para a próxima página
  const navigateToNextScreen = () => {
    setShowModalSucesso(false);
    //Checar aqui para qualquestionário navegar (por ora navegando direto para o da OMS)
    return navigate(Paths.OMSQuestionnaire);
  };

  // Essa função fica esperando a validação e se caso o return for true,
  //manda as informações para api
  async function save() {
    debugger
    if (!(await validate())) return;

    try {
      await dispatch(personActions.updatePersonInfo(information, pessoa.id));
    } catch (error: any) {
      handleBackendErrors(error, setGeneralErrors);
      return;
    }
    if (selectedFile) {
      try {
        await dispatch(personActions.uploadPhoto(selectedFile));
      } catch (error: any) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setGeneralErrors([{ message: 'Erro ao atualizar foto de perfil' }])
      }
    }
    setShowModalSucesso(true);

    // Abrir o modal de sucesso
  }

  // Mask para telefones
  function masktel(name: any, v: any) {
    setTimeout(() => {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");
      setInformation({ ...information, [name]: v });
    }, 1);
  }

  // Regras de validação
  const schema = Yup.object().shape({
    nomeChamado: Yup.string()
      .max(150)
      .min(5, "Preencha pelo menos 5 caracteres")
      .required("Como quer ser chamado é um campo obrigatório")
      .test("validar-nome", "Digite apenas letras", (value) => {
        return validateOnlyLetters(value ?? "") === true;
      }),
    email: Yup.string()
      .email("E-mail inválido!")
      .max(50)
      .required("E-mail do responsável é um campo obrigatório"),
    confirmaEmail: Yup.string()
      .email("E-mail inválido!")
      .oneOf([Yup.ref('email'), null], 'Os emails precisam ser iguais.')
      .required('A confirmação de email é obrigatória.'),


    telefone1: Yup.string()
      .required("Telefone do responsável é um campo obrigatório")
      .test("validar-telefone", "Telefone inválido", (value) => {
        return validateTelephone(value ?? "") === true;
      }),
    telefone2: Yup.string().test(
      "validar-telefone",
      "Telefone (2) inválido",
      (value) => {
        return validateTelephone(value ?? "") === true || value === "";
      }
    ),
    nomeContatoUrgencia: Yup.string()
      .max(150)
      .min(5, "Preencha pelo menos 5 caracteres")
      .required("Nome é um campo obrigatório")
      .test("validar-nome", "Digite apenas letras", (value) => {
        return validateOnlyLetters(value ?? "") === true;
      }),
    grauParentesco: Yup.string()
      .max(20)
      .min(3, "Preencha pelo menos 3 caracteres")
      .required("Grau parentesco é um campo obrigatório")
      .test("validar-nome", "Digite apenas letras", (value) => {
        return validateOnlyLetters(value ?? "") === true;
      }),
    telefoneUrgencia: Yup.string()
      .required("Telefone para contato urgênte é um campo obrigatório")
      .test("validar-telefone", "Telefone inválido", (value) => {
        return validateTelephone(value ?? "") === true;
      }),
    emailUrgencia: Yup.string()
      .email("E-mail inválido!")
      .max(50, "E-mail não pode ter mais de 50 caracteres!")
      .required("E-mail para contato urgênte é um campo obrigatório"),
  });

  const errors = (
    errorNome: any,
    errorEmail: any,
    errorConfirmaEmail: any,
    errorTel1: any,
    errorTel2: any,
    errorContactUrgent: any,
    errorGrauParents: any,
    errorTelUrgent: any,
    errorEmilUrgent: any
  ) => {
    setNomeError(errorNome);
    setEmailError(errorEmail);
    setConfirmaEmailError(errorConfirmaEmail);
    setTel1Error(errorTel1);
    setTel2Error(errorTel2);
    setNomeUrgentError(errorContactUrgent);
    setGrauParentescoError(errorGrauParents);
    setTelUrgentError(errorTelUrgent);
    setEmailUrgentError(errorEmilUrgent);
  };

  // Validar todos os campos antes de prosseguir
  async function validate() {
    try {
      await schema.validate(information, { abortEarly: false });
      errors([], [], [], [], [], [], [], [], []);
      return true;
    } catch (err: any) {
      if (err instanceof Yup.ValidationError) {
        let errorNome = [] as any;
        let errorEmail = [] as any;
        let errorConfirmaEmail = [] as any;
        let errorTel1 = [] as any;
        let errorTel2 = [] as any;
        let errorContactUrgent = [] as any;
        let errorGrauParents = [] as any;
        let errorTelUrgent = [] as any;
        let errorEmilUrgent = [] as any;

        err.inner.forEach((error: any) => {
          if (error.path) {
            switch (error.path) {
              case "nomeChamado":
                errorNome.push(error.message);
                break;
              case "email":
                errorEmail.push(error.message);
                break;
              case "confirmaEmail":
                errorConfirmaEmail.push(error.message);
                break;                
              case "telefone1":
                errorTel1.push(error.message);
                break;
              case "telefone2":
                errorTel2.push(error.message);
                break;
              case "nomeContatoUrgencia":
                errorContactUrgent.push(error.message);
                break;
              case "grauParentesco":
                errorGrauParents.push(error.message);
                break;
              case "telefoneUrgencia":
                errorTelUrgent.push(error.message);
                break;
              case "emailUrgencia":
                errorEmilUrgent.push(error.message);
                break;
            }
          }
        });
        errors(
          errorNome,
          errorEmail,
          errorConfirmaEmail,
          errorTel1,
          errorTel2,
          errorContactUrgent,
          errorGrauParents,
          errorTelUrgent,
          errorEmilUrgent
        );
      }
      return false;
    }
  }

  return (
    <GeneralContainerCenter>
      {pessoa !== null && (
        <div style={{ margin: isMobile ? "10px" : "" }}>
          <TitleLarge color="#575757">Informações complementares</TitleLarge>
          <SubTitle>Preencha os campos com os seus dados de contato.</SubTitle>
          <ErrorArea errorList={generalErrors} onCloseAction={() => { setGeneralErrors([]) }} />

          <ContainerInformations>
            <div>
              <CardUploadPhoto
                imageNotAllowedByExtension={imageNotAllowedByExtension}
                imageNotAllowedBySize={imageNotAllowedBySize}
                preview={preview}
                onChange={onSelectFile}
                selectedFile={selectedFile}
              />
            </div>
            <div>
              {/* Informações complementares */}
              <LabelInputBorderFull
                style={{ backgroundColor: Colors.GRAY200, cursor: "default" }}
                name={"nomeCompleto"}
                value={information.nomeCompleto}
                type={"text"}
                label={"Nome Completo"}
                placeholder={"Nome Completo"}
                disabled={true}
                isMandatory={false}
                isInvalid={true}
                msgError={[]}
                onChangeText={valueFields}
                max={0}
              />
              <LabelInputBorderFull
                style={{ backgroundColor: Colors.GRAY200, cursor: "default" }}
                name={"cpf"}
                type={"text"}
                value={information.cpf}
                label={"CPF"}
                placeholder={"CPF"}
                disabled={true}
                isMandatory={false}
                isInvalid={true}
                msgError={[]}
                onChangeText={valueFields}
                max={0}
              />
              <LabelInputBorderFull
                style={
                  pessoa.dataNascimento === null
                    ? {}
                    : { backgroundColor: Colors.GRAY200, cursor: "default" }
                }
                name={"dataNascimento"}
                value={information.dataNascimento}
                type={"date"}
                label={"Data de Nascimento"}
                placeholder={"Data de Nascimento"}
                disabled={pessoa.dataNascimento !== null}
                isMandatory={false}
                isInvalid={true}
                msgError={[]}
                onChangeText={valueFields}
                max={10}
              />

              <LabelInputBorderFull
                name={"nomeChamado"}
                value={information.nomeChamado}
                type={"text"}
                label={"Como gostaria de ser chamado"}
                placeholder={"Como gostaria de ser chamado"}
                disabled={false}
                isMandatory={true}
                isInvalid={nomeError.length === 0 ? true : false}
                msgError={nomeError}
                onChangeText={valueFields}
                max={150}
              />

              {/* Informações de contato  */}
              <div style={{ marginTop: "64px" }}>
                {/* Informações de contato  */}
                <div style={{ marginTop: "64px" }}>
                  <H2>Informações de contato</H2>
                  <SubTitle>
                    Preencha os campos com os seus dados de contato.
                  </SubTitle>
                  <LabelInputBorderFull
                    name={"email"}
                    value={information.email}
                    type={"email"}
                    label={"Seu email"}
                    placeholder={"Seu email"}
                    disabled={false}
                    isMandatory={true}
                    isInvalid={emailError.length === 0 ? true : false}
                    msgError={emailError}
                    onChangeText={valueFields}
                    max={50}
                  />
                  <LabelInputBorderFullEmail
                    name={"confirmaEmail"}
                    value={information.confirmaEmail}
                    type={"email"}
                    label={"Confirme seu email"}
                    placeholder={"Confirme seu email"}
                    disabled={false}
                    isMandatory={true}
                    isInvalid={confirmaEmailError.length === 0 ? true : false}
                    msgError={confirmaEmailError}
                    onChangeText={valueFields}
                    max={50}
                  />                  
                  <LabelInputBorderFull
                    name={"telefone1"}
                    value={information.telefone1}
                    type={"tel"}
                    label={"Telefone para contato"}
                    placeholder={"Telefone para contato"}
                    disabled={false}
                    isMandatory={true}
                    isInvalid={tel1Error.length === 0 ? true : false}
                    msgError={tel1Error}
                    onChangeText={valueFields}
                    max={15}
                  />
                  <LabelInputBorderFull
                    name={"telefone2"}
                    value={information.telefone2}
                    type={"tel"}
                    label={"Telefone para contato (2)"}
                    placeholder={"Telefone para contato (2)"}
                    disabled={false}
                    isMandatory={false}
                    isInvalid={tel2Error.length === 0 ? true : false}
                    msgError={tel2Error}
                    onChangeText={valueFields}
                    max={15}
                  />
                </div>
                {/* Contato para urgência */}
                <div style={{ marginTop: "78px" }}>
                  <H2>Contato para urgência</H2>
                  <SubTitle>
                    Preencha os campos com os dados da pessoa que devemos entrar
                    em contato em caso de urgência.
                  </SubTitle>
                  <LabelInputBorderFull
                    name={"nomeContatoUrgencia"}
                    type={"text"}
                    value={information.nomeContatoUrgencia}
                    label={"Nome do contato em caso de urgência"}
                    placeholder={"Nome do contato em caso de urgência"}
                    disabled={false}
                    isMandatory={true}
                    isInvalid={nomeUrgentErro.length === 0 ? true : false}
                    msgError={nomeUrgentErro}
                    onChangeText={valueFields}
                    max={150}
                  />
                  <LabelInputBorderFull
                    name={"grauParentesco"}
                    value={information.grauParentesco}
                    type={"text"}
                    label={"Grau de parentesco do contato em caso de urgência"}
                    placeholder={
                      "Grau de parentesco do contato em caso de urgência"
                    }
                    disabled={false}
                    isMandatory={true}
                    isInvalid={grauParentescoErro.length === 0 ? true : false}
                    msgError={grauParentescoErro}
                    onChangeText={valueFields}
                    max={20}
                  />
                  <LabelInputBorderFull
                    name={"telefoneUrgencia"}
                    value={information.telefoneUrgencia}
                    type={"tel"}
                    label={"Telefone para contato em caso de urgência"}
                    placeholder={"Telefone para contato de urgência"}
                    disabled={false}
                    isMandatory={true}
                    isInvalid={telUrgentErro.length === 0 ? true : false}
                    msgError={telUrgentErro}
                    onChangeText={valueFields}
                    max={15}
                  />
                  <LabelInputBorderFull
                    name={"emailUrgencia"}
                    value={information.emailUrgencia}
                    type={"email"}
                    label={"Email do contato em caso de urgência"}
                    placeholder={"Email do contato em caso de urgência"}
                    disabled={false}
                    isMandatory={true}
                    isInvalid={emailUrgentErro.length === 0 ? true : false}
                    msgError={emailUrgentErro}
                    onChangeText={valueFields}
                    max={50}
                  />
                </div>
              </div>
              <div style={{ marginTop: "30px", marginBottom: "78px" }}>
                <FilledButton onClick={() => save()} width={25} color="#0A5190">
                  Salvar meus dados
                </FilledButton>
              </div>
            </div>
          </ContainerInformations>
        </div>
      )}

      <SuccessModal
        Icon={() => {
          return <MedicineCheck />;
        }}
        modalMsg="Dados salvos com sucesso!"
        BtnText="Continuar para o Questionário de Saúde"
        visible={showModalSucesso}
        onVoltar={navigateToNextScreen}
      />
    </GeneralContainerCenter>
  );
}

export default InformationsCpt;
